import { AModel } from '../../../../api/abstracts/model.abstract';

export class BuyProgramModel extends AModel {
    public fillables: any = {
        APR: 'APR',
        Terms: 'Terms',
        EcsType: 'EcsType',
        OfferType: 'OfferType',
        IsSelected: 'IsSelected',
        DownPayment: 'DownPayment',
        ApprovalDate: 'ApprovalDate',
        TemplateName: 'TemplateName',
        ErrorMessage: 'ErrorMessage',
        BuyProgramId: 'BuyProgramId',
        LTVPercentage: 'LTVPercentage',
        ExpirationDate: 'ExpirationDate',
        ApprovedAmount: 'ApprovedAmount',
        MonthlyPayment: 'MonthlyPayment',
        BuyProgramType: 'BuyProgramType',
        RatePercentage: 'RatePercentage',
        GAPWaiverAmount: 'GAPWaiverAmount',
        ApprovedAmountText: 'ApprovedAmountText',
        MinimumVehicleYear: 'MinimumVehicleYear',
        MaximumVehicleMiles: 'MaximumVehicleMiles',
        MinimumAmountFinanced: 'MinimumAmountFinanced',
        MaximumAmountFinanced: 'MaximumAmountFinanced',
        PowertrainCoverageAmt: 'PowertrainCoverageAmt',
        AdvantageCoverageAmt: 'AdvantageCoverageAmt',
        IsGAPWaiverSelected: 'IsGAPWaiverSelected',
    }
    public defaults: any = {
        EcsType: 0,
        IsSelected: false,
        GAPWaiverAmount: 0,
        AdvantageCoverageAmt: 0,
        PowertrainCoverageAmt: 0,
        IsGAPWaiverSelected: false,
    }
    constructor (args) {
        super(args)
        this.init(args, this);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auto-loans/models/buy-program.model.ts